// src/utils/sidebarUtils.ts

import { SidebarItem } from "../app/models/SidebarItem";

export const filterSidebarItems = (
  items: SidebarItem[],
  search: string
): { results: SidebarItem[]; openKeys: number[] } => {
  const openKeys: number[] = [];

  const filteredResults = items.reduce<SidebarItem[]>((acc, item) => {
    const itemMatches = item.name.toLowerCase().includes(search.toLowerCase());

    if (itemMatches) {
      acc.push(item);
      openKeys.push(item.id);
      if (item.parent_item_id) openKeys.push(item.parent_item_id);
    } else if (item.children) {
      const filteredChildren = filterSidebarItems(item.children, search);
      if (filteredChildren.results.length > 0) {
        acc.push({ ...item, children: filteredChildren.results });
        openKeys.push(item.id);
        if (item.parent_item_id) openKeys.push(item.parent_item_id);
        openKeys.push(...filteredChildren.openKeys);
      }
    }

    return acc;
  }, []);

  return { results: filteredResults, openKeys: Array.from(new Set(openKeys)) };
};
